<template>
  <div class="gold-view login-box" :class="isCjehApp() ? 'cjeh-app' : ''">
    <div class="header">
      <div class="header-content">
        <div class="header-button header-back" @click="goBack()"></div>
        <h1>报名登录</h1>
      </div>
    </div>
    <div class="view-scroller has-header has-footer">
      <div class="header-box">
        <!-- <img src="../assets/header-bgc.png" alt="" /> -->
        <img src="../assets/nextIndex/header-bgr.png" alt="" />
      </div>
      <div class="content-box">
        <!-- <div class="title">
          <img src="../assets/net-value.png" alt="" />
        </div> -->
        <div class="cell">
          <input
            type="number"
            v-model="i_mobile"
            class="font-title-color right-span"
            maxlength="11"
            placeholder="手机号码"
            @blur="blurEvent(i_mobile)"
          />
        </div>
        <div class="cell has-right">
          <input
            type="text"
            class="font-title-color right-span"
            v-model="messgeCode"
            placeholder="图形验证码"
          />
          <div class="verification-code" @click="getValidateImg(true)">
            <img :src="imgUrl" />
          </div>
        </div>
        <div class="cell">
          <input
            type="number"
            class="font-title-color right-span"
            maxlength="11"
            v-model="i_verify_code"
            placeholder="手机验证码"
          />
          <div
            class="verification-code code-color"
            ref="countDown"
            @click="sendMsg(true)"
          >
            获取验证码
          </div>
        </div>
      </div>
    </div>
    <div class="button footer" @click="goValue">登录</div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import cjServices from '../services/cjServices.js'
import nativeService from '../services/common/nativeService.js'
// import cache from '../proxy/cache.js'
export default {
  data (){
    return {
      i_mobile: '',
      messgeCode: '',
      // 图片返回的url 和id
      imgUrl: '',
      sessionId:'',
      // 短信发送成功后返回的验证码和短信序列号
      i_verify_code: '',
      i_serial_no: '',
      countTime: 0
    }
  },
  methods:{
    // 点击登录
    goValue() {
      if(!this.i_mobile) {
        Toast({
          message:'请输入手机号码',
          duration: 2000
        })
        return false
      } else if(!cjServices.checkMobile(this.i_mobile)){
        Toast({
          message:'输入手机号格式不正确',
          duration: 2000
        })
        return false
      }
      if(!this.i_verify_code) {
        Toast({
          message:'请输入手机验证码',
          duration: 2000
        })
        return false
      }
      const data = {
        i_mobile : this.i_mobile,
        i_verify_code : this.i_verify_code,
        i_serial_no : this.i_serial_no,
      }
      cjServices.login(this,data).then(res => {
        if (res.body && res.body.error_code == '0') {
          const goldCJToken = res.body.goldCJToken || ''
          sessionStorage.setItem("goldCJToken", goldCJToken)
          console.log(goldCJToken,'登录返回的数据')
        } else {
          Toast({
            message: res.body.error_info,
            duration: 2000
          });
          return false
        }
        nativeService.routerRedirect('/signUp', this)
        // nativeService.routerRedirect('/weekList', this)
      })
    },
    // 点击发送手机号
    sendMsg(flag) {
      if(!this.i_mobile) {
        Toast({
          message:'请输入手机号码',
          duration: 2000
        })
        return false
      }else if(!cjServices.checkMobile(this.i_mobile)) {
        Toast({
          message:'输入手机号格式不正确',
          duration: 2000
        })
        return false
      }
      if(!this.messgeCode) {
        Toast({
          message:'请输入图形验证码',
          duration: 2000
        })
        return false
      }
      if(this.countTime > 0) {
        return false
      }
      const data = {
        sessionId: this.sessionId,
        validateCode:this.messgeCode,
        i_mobile:this.i_mobile
      }
      cjServices.sendCode(this,data).then(res => {
        if (res.body && res.body.error_code == '0') {
          Toast({
            message: '短信验证码发送成功',
            duration: 2000
          })
          this.getValidateImg()
          if(flag){
            this.i_serial_no = res.body.results.length > 0 ?  res.body.results[0].serial_no : ''
            this.countTime = 60
            const that = this
            var timer = setInterval(() => {
                if (that.$refs&&that.$refs.countDown&&that.$refs.countDown.innerText) {
                  that.$refs.countDown.innerText = that.countTime + 's'
                  if (that.countTime-- <= 0) {
                    that.countTime = 0
                    that.$refs.countDown.innerText = '获取验证码'
                    clearInterval(timer)
                  }
                }
              }, 1000)
          }
        } else {
          Toast({
            message: res.body.error_info,
            duration: 2000
          })
          return false
        }
      })

    },
    // 获取图片二维码
    getValidateImg() {
      cjServices.getValidateImg(this).then(function(response) {
        if (response.body && response.body.error_code == '0') {
            this.imgUrl = 'data:image/png;base64,' + response.body.results.base64Str
            this.sessionId = response.body.results.sessionId
        } else {
          Toast({
            message: response.body.error_info,
            duration: 2000
          })
          // alert(response.body.error_info)
        }
      })
    },
    blurEvent() {
        if (this.i_mobile != '' && !cjServices.checkMobile(this.i_mobile)) {
          Toast({
            message: '请输入正确的手机号码',
            duration: 1000
          })
          return false
        }
    },
    goBack() {
      nativeService.routerRedirect(-1, this)
    },
    isCjehApp() {
      if (navigator.userAgent.indexOf('cjsccjeh') > -1) {
        return true
      } else {
        return false
      }

    }
  },
  created() {
    this.getValidateImg(true)
  }
}
</script>

<style lang="scss" scoped>
@import "sass/gold/common.scss";
@import "sass/gold/login.scss";
</style>
